import { defineMessages } from 'react-intl'

export default defineMessages({
  review1: {
    id: 'Home.appStoreReviews.text1',
    defaultMessage:
      '5/5 loveee this app, helps me stay on track and it’s easy to use! Best fitness app to keep track!',
  },
  review2: {
    id: 'Home.appStoreReviews.text2',
    defaultMessage:
      'Seriously, I’ve tried it all. Get this! It’s super easy, and if you want personalized help it’s CHEAP and WORTH EVERY PENNY. I’m a happier, healthier gal.',
  },
  review3: {
    id: 'Home.appStoreReviews.text3',
    defaultMessage:
      'This app is so helpful that I bought the premium version. In this first week of using The Energizer I have lost over 7 pounds!',
  },
  review4: {
    id: 'Home.appStoreReviews.text4',
    defaultMessage:
      'This is the best app I’ve tried so far. It finds EVERYTHING. The insights are so helpful and have made me more conscious of what I’m eating. The recipes look great, interface is intuitive and user-friendly. I just upgraded to Premium and excited to keep using this app!',
  },
  review5: {
    id: 'Home.appStoreReviews.text5',
    defaultMessage:
      'I have tried many different calorie counting apps and have never been able to stick to them. However, I have been using lifesum for a while now and am absolutely loving it!! I even bought the premium version! I also have an Apple Watch and love the little green apple that motivates me to move & and drink my water! &lt;3',
  },
  review6: {
    id: 'Home.appStoreReviews.text6',
    defaultMessage:
      'Easy to use, love the interface and how it has recipes and keeps me on plan. I upgraded to the full version, no regrets! I’ve tried many apps and in my opinion this one is the simplest to use and guides my choices!',
  },
  review7: {
    id: 'Home.appStoreReviews.text7',
    defaultMessage:
      'I love this app! It has so many features and great advice. With the different meal plans and exact calorie counts, this app was perfect for me.',
  },
})
